/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, BytesLike } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { GenericHandler } from "./GenericHandler";

export class GenericHandlerFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    bridgeAddress: string,
    initialResourceIDs: BytesLike[],
    initialContractAddresses: string[],
    initialDepositFunctionSignatures: BytesLike[],
    initialExecuteFunctionSignatures: BytesLike[],
    overrides?: Overrides
  ): Promise<GenericHandler> {
    return super.deploy(
      bridgeAddress,
      initialResourceIDs,
      initialContractAddresses,
      initialDepositFunctionSignatures,
      initialExecuteFunctionSignatures,
      overrides || {}
    ) as Promise<GenericHandler>;
  }
  getDeployTransaction(
    bridgeAddress: string,
    initialResourceIDs: BytesLike[],
    initialContractAddresses: string[],
    initialDepositFunctionSignatures: BytesLike[],
    initialExecuteFunctionSignatures: BytesLike[],
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      bridgeAddress,
      initialResourceIDs,
      initialContractAddresses,
      initialDepositFunctionSignatures,
      initialExecuteFunctionSignatures,
      overrides || {}
    );
  }
  attach(address: string): GenericHandler {
    return super.attach(address) as GenericHandler;
  }
  connect(signer: Signer): GenericHandlerFactory {
    return super.connect(signer) as GenericHandlerFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GenericHandler {
    return new Contract(address, _abi, signerOrProvider) as GenericHandler;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "bridgeAddress",
        type: "address",
      },
      {
        internalType: "bytes32[]",
        name: "initialResourceIDs",
        type: "bytes32[]",
      },
      {
        internalType: "address[]",
        name: "initialContractAddresses",
        type: "address[]",
      },
      {
        internalType: "bytes4[]",
        name: "initialDepositFunctionSignatures",
        type: "bytes4[]",
      },
      {
        internalType: "bytes4[]",
        name: "initialExecuteFunctionSignatures",
        type: "bytes4[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "_bridgeAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "_contractAddressToDepositFunctionSignature",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "_contractAddressToExecuteFunctionSignature",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "_contractAddressToResourceID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "_contractWhitelist",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    name: "_depositRecords",
    outputs: [
      {
        internalType: "uint8",
        name: "_destinationChainID",
        type: "uint8",
      },
      {
        internalType: "address",
        name: "_depositer",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "_resourceID",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "_metaData",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "_resourceIDToContractAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "depositNonce",
        type: "uint64",
      },
      {
        internalType: "uint8",
        name: "destId",
        type: "uint8",
      },
    ],
    name: "getDepositRecord",
    outputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "_destinationChainID",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "_depositer",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "_resourceID",
            type: "bytes32",
          },
          {
            internalType: "bytes",
            name: "_metaData",
            type: "bytes",
          },
        ],
        internalType: "struct GenericHandler.DepositRecord",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "depositFunctionSig",
        type: "bytes4",
      },
      {
        internalType: "bytes4",
        name: "executeFunctionSig",
        type: "bytes4",
      },
    ],
    name: "setResource",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "uint8",
        name: "destinationChainID",
        type: "uint8",
      },
      {
        internalType: "uint64",
        name: "depositNonce",
        type: "uint64",
      },
      {
        internalType: "address",
        name: "depositer",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "executeProposal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
